// extracted by mini-css-extract-plugin
module.exports = {"marquee":"CompanyLogos_marquee__Nhiiq","marqueeGroup":"CompanyLogos_marqueeGroup__HxiPq","scroll":"CompanyLogos_scroll__Zco90"};